import { useEffect, useRef } from 'preact/hooks'
import { useSearchspringContext } from 'libs/searchspring/fetchers/provider'
import { useIntersectionObserver } from '@/components/hooks/useIntersectionObserver'
import { usePageTracker } from 'libs/searchspring/hooks/usePageTracker'

export function InfiniteScrollNext() {
  const { results, refine, isLoading } = useSearchspringContext()
  const { loadedPages } = usePageTracker()
  const totalPages = results?.pagination?.totalPages ?? 1
  const { setNode, entry } = useIntersectionObserver({
    rootMargin: '300px',
    threshold: 0.1
  })

  useEffect(() => {
    if (isLoading) return
    if (entry?.isIntersecting) {
      handleNextPage()
    }
  }, [entry])

  const handleNextPage = () => {
    const nextPage = loadedPages[loadedPages.length - 1] + 1
    if (nextPage > totalPages) return
    refine('page', nextPage)
  }

  // Hide load more if all pages are loaded
  if (loadedPages[loadedPages.length - 1] >= totalPages) return null
  return (
    <div ref={setNode} className="col-span-full flex items-center justify-center">
      <div className="relative w-12 h-12 animate-spin">
        <svg width="48" height="48" viewBox="0 0 50 51" fill="none" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <mask id="gradient-mask">
              <rect width="50" height="51" fill="black"/>
              <circle cx="25" cy="25.814" r="21" fill="none" stroke="url(#fade-gradient)" strokeWidth="8"/>
            </mask>
            <linearGradient id="fade-gradient" x1="21.5" y1="20.1852" x2="40.5" y2="43.1852" gradientUnits="userSpaceOnUse">
              <stop offset="0%" stopColor="white"/>
              <stop offset="100%" stopColor="black"/>
            </linearGradient>
            <linearGradient id="color-gradient" x1="21.5" y1="20.1852" x2="40.5" y2="43.1852" gradientUnits="userSpaceOnUse">
              <stop offset="0%" stopColor="#B3B3B3"/>
              <stop offset="100%" stopColor="white"/>
            </linearGradient>
          </defs>
          <circle cx="25" cy="25.814" r="21" stroke="url(#color-gradient)" strokeWidth="8" mask="url(#gradient-mask)"/>
        </svg>
      </div>
    </div>
  )
}

export function InfiniteScrollPrevious() {
  const { refine, isLoading } = useSearchspringContext()
  const { loadedPages } = usePageTracker()
  const hasBeenClicked = useRef(false)
  const { setNode, entry } = useIntersectionObserver({
    rootMargin: '100px',
    threshold: 1
  })

  useEffect(() => {
    if (!hasBeenClicked.current) return
    if (isLoading) return
    if (entry?.isIntersecting) {
      handlePrevPage()
    }
  }, [entry])

  const handleClick = () => {
    hasBeenClicked.current = true
    handlePrevPage()
  }

  // Handle previous page based on array of loaded pages
  const handlePrevPage = () => loadedPages.length && loadedPages[0] !== 1 && refine('page', loadedPages[0] - 1)

  // Hide load previous if first page is loaded
  if (!loadedPages.length || loadedPages[0] === 1) return null
  return (
      <div className="col-span-full flex items-center justify-center gap-x-1 lg-max:pt-1">
        <button
          ref={setNode}
          className="btn !capitalize btn-primary btn-m"
          onClick={handleClick}
          aria-label="Load Previous"
        >
          Load Previous
        </button>
      </div>
  )
}
